<template>
  <Modal :title="title" :showModal="showModal" class="edit-user-form" @submit="submit">
    <template v-slot:body>
      <div class="row">
        <div v-if="action == 'create'" class="position-relative form-group col-12">
          <label class="col-12 mb-0 p-0">User*</label>
          <input class="form-control mt-2" type="text" name="user_name" autocomplete="new-password" @change.stop.prevent="store.commit('user_name', $event.target.value)" />
        </div>
        <div class="position-relative form-group col-12">
          <label class="col-12 mb-0 p-0">Email*</label>
          <input class="form-control mt-2" type="email" name="email" autocomplete="new-password" :value="data.email" @change.stop.prevent="store.commit('email', $event.target.value)" />
        </div>
        <div class="position-relative form-group col-12">
          <label class="col-12 mb-0 p-0">Password</label>
          <input class="form-control mt-2" type="password" name="password" :placeholder="action == 'create' ? '' : 'No change'" @change.stop.prevent="store.commit('password', $event.target.value)" autocomplete="new-password" />
        </div>
        <div class="position-relative form-group col-12">
          <label class="col-12 mb-0 p-0">Display Name*</label>
          <input class="form-control mt-2" type="text" :value="data.display_name" @change.stop.prevent="store.commit('display_name', $event.target.value)" />
        </div>
        <div class="position-relative form-group col-12">
          <label class="col-12 mb-2 p-0">Role*</label>
          <Select placeholder="User Role" :options="roleOptions" :value="data.role" @changeValue="changeUserRole"></Select>
        </div>
        <div v-show="userParent" class="position-relative form-group col-12">
          <label class="col-12 mb-2 p-0">Parent</label>
          <Select source="user/search" type="auto" field="user.user_read_in_team" placeholder="User Login Parent" :value="data.parent_id" @changeValue="store.commit('parent_id', $event)"></Select>
        </div>
        <div v-if="action != 'create'" class="position-relative form-group col-12">
          <label class="col-12 mb-2 p-0">Status</label>
          <Select :options="listStatus" placeholder="Status" :value="data.status" @changeValue="store.commit('status', $event)"></Select>
        </div>

        <div class="position-relative form-group col-12">
          <label class="col-12 mb-2 p-0">Connection</label>
          <input class="form-control" type="text" placeholder="Telegram user name" :value="meta.connection.telegram.user_name" @change.stop.prevent="store.commit('meta.connection.telegram.user_name', $event.target.value)" />
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import Event from '@/helper/event.js'

export default {
  mixins: [Event],
  computed: {
    title() {
      return this.data?.status == 'draft' ? 'Create User' : 'Edit User'
    },
    action() {
      return this.data?.status != 'draft' ? 'edit' : 'create'
    },
    storeId() {
      return this.config?.storeId
    },
    userId() {
      return this.config?.data?._id
    },
    getUri() {
      return `user/get/${this.userId}`
    },
    submitUri() {
      return `user/update/${this.userId}`
    },
    data() {
      return this.store.getter('', {})
    },
    meta() {
      return Object.assign(
        {
          connection: {
            telegram: {
              user_name: ''
            }
          }
        },
        this.data?.meta || {}
      )
    },
    more() {
      return this.data?.more || {}
    },
    listStatus() {
      return Object.values(
        this.$util.map(this.more?.status || {}, ({ item, key }) => {
          return {
            id: key,
            text: item.text
          }
        })
      )
    },
    roleOptions() {
      return Object.values(this.more?.roles || {})
    },
    userParent() {
      let userParent = this.roleOptions.filter((item) => {
        return this.data?.role == item?.id && this.more?.level == 'owner' && item?.level == 'author'
      })
      return userParent.length > 0
    }
  },
  created() {
    this.store.commit('', {})
  },
  methods: {
    changeUserRole(value) {
      this.store.commit('role', value)
    },
    changeUserParent(value) {
      this.store.commit('parent_id', value)
    },
    setUpData(rawData) {
      if (rawData.status == 'success') {
        this.showModal = true
        rawData.data.meta.connection = Object.assign({}, rawData.data.meta.connection)
        Object.keys(rawData.data.more.bots).forEach((item) => {
          if (!rawData.data.meta.connection[item]) {
            rawData.data.meta.connection[item] = {}
          }
        })
        this.store.commit('', rawData.data)
      }
    },
    submit() {
      let data = this.data
      if (this.action == 'create') {
        data = Object.assign(data, {
          status: 'active'
        })
      }
      this.submitForm(data, {
        done: () => {
          this.$emit('close')
          this.$emitter.emit('TableList.Refresh')
        }
      })
    }
  },
  props: {
    config: Object
  }
}
</script>

<style lang="scss">
#modal-container {
  .modal.edit-user-form {
    .modal-body {
      overflow: unset;
    }
  }
}
</style>
